// extracted by mini-css-extract-plugin
export default {"submissionSuccess":"submissionSuccess__SubmissionSuccess__q0gD1","thankyou":"thankyou__SubmissionSuccess__q0gD1"};